import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_female_walking_sound_effects~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_female_walking_sound_effects'),
			},
		},
	},
]

export default config
